export default {
  data() {
    return {
      total: 0,
      currentPage: 1,
      currentPageSize: 10
    };
  },

  methods: {
    currentChange(page) {
      this.currentPage = page;
      this.getList(page);
    },

    sizeChange(size) {
      this.currentPageSize = size;
      this.getList(1, size);
    }
  }
};
